{
  "de": {
    "courseDetail": {
      "headers": {
        "title": "Kursdetails"
      },
      "labels": {
        "course": "Online-Fortbildung",
        "webinar": "Live-Webinar",
        "impulse": "fobizz Impuls",
        "workshop": "Workshop"
      },
      "headings": {
        "learningGoals": "Lernziele",
        "lessons": "Inhalte",
        "recommendations": "Diese Themen könnten dich auch interessieren",
        "feedbacks": "Rezensionen"
      },
      "buttons": {
        "startNextLesson": "Starte die nächste Einheit",
        "startImpulse": "Starte den Impuls",
        "enrollFree": "Jetzt einschreiben",
        "enrollFreeGroup": "Jetzt einschreiben",
        "enrollFreeSubscription": "Jetzt einschreiben",
        "enrollSubscription": "Flatrate abschließen",
        "enrollInternationalSubscription": "fobizz Lizenz",
        "orderFreeFlatrate": "Flatrate testen",
        "getStarted": "Jetzt anmelden",
        "downloadCertificate": "Zertifikat herunterladen",
        "showMore": "Mehr anzeigen...",
        "bookmark": "Merken",
        "unbookmark": "Entfernen",
        "completeWebinar": "Webinar abschließen"
      },
      "sidebar": {
        "content": "Fortbildungsinhalte",
        "author": "Autor*in",
        "feedback": "Rezensionen",
        "certificate": "Zertifikat",
        "speaker": "Referent*in",
        "accessInfo": "Zugangsdaten",
        "recording": "Aufzeichnung",
        "documents": "Unterlagen",
        "info": "Allgemeine Informationen",
        "navLabel": "Kursnavigation"
      },
      "enrollment": {
        "expired": "Dein Zugang zu dieser Fortbildung ist abgelaufen",
        "expiredAt": "Dein Zugang zu dieser Fortbildung ist am {date} abgelaufen",
        "accessUntil": "Du hast noch bis zum {date} Zugriff auf diese Fortbildung.",
        "freeHint": "Kurs ist kostenfrei",
        "closedHint": "Keine Einschreibung mehr möglich",
        "vidisHint": "Mit deinem {vidis} Konto kannst du dieses Angebot nicht direkt buchen. Bitte schicke eine Mail an {emailLink}.",
        "paidHintFlatrate": "Mit einer {flatrateLink} bekommst du ab {price} Zugriff auf alle Kurse für ein Jahr.",
        "paidHintCoupon": "Mit dem Code {couponLink} kannst du für einen Monat unverbindlich alle Kurse, KI und Tools testen."
      },
      "webinar": {
        "startsAt": "Die Teilnahmeinformationen für das Webinar werden kurz vorher hier eingeblendet.",
        "startsAtFuture": "Das Webinar findet statt am <strong>{date} von {start} bis {end} Uhr {timezone}</strong>.",
        "startsAtPast": "Das Webinar fand statt am <strong>{date} von {start} bis {end} Uhr {timezone}</strong>.",
        "startsAtNow": "Das Webinar findet jetzt gerade statt von <strong>{start} bis {end} Uhr {timezone}</strong>.",
        "startsAtToday": "Das Webinar findet heute statt von <strong>{start} bis {end} Uhr {timezone}</strong>.",
        "startsAtTodayPast": "Das Webinar fand heute statt von <strong>{start} bis {end} Uhr {timezone}</strong>.",
        "recordingHint": "Von dieser Veranstaltung wird es eine Aufzeichnung geben.",
        "noRecording": "Von dieser Veranstaltung wird es keine Aufzeichnung geben."
      },
      "accessInfo": {
        "recordingHintHtml": "Hinweis: Die Untertitel in unseren Videos werden automatisch generiert. Es kann sein, dass nicht alle Begriffe korrekt wiedergegeben werden. Wenn du Feedback zu den Untertiteln hast, melde dich unter <a href=\"mailto:support{'@'}fobizz.com\" target=\"_blank\">support{'@'}fobizz.com</a>",
        "recordingPending": "Die Aufzeichnung wird noch verarbeitet. Sobald sie verfügbar ist, wird sie hier eingeblendet.",
        "noRecording": "Für dieses Webinar gibt es keine Aufzeichnung."
      },
      "feedback": {
        "emptyHint": "Diese Fortbildung ist neu. Es gibt noch keine Rezensionen - aber wir freuen uns schon auf erstes Feedback.",
        "carousel": {
          "previous": "Zurück",
          "next": "Weiter"
        }
      },
      "feedbackNew": {
        "heading": "Abschluss und Feedback",
        "complete": "Bitte beende alle Lektionen, um Feedback abzugeben. Danke!",
        "existing": "Du hast bereits Feedback gegeben. Vielen Dank dafür!",
        "downloadCertificate": "Zertifikat herunterladen",
        "form": {
          "rating": "Wie bewertest du diese Fortbildung allgemein?",
          "ratingLabels": {
            "1": "Schrecklich",
            "2": "Schlecht",
            "3": "Okay",
            "4": "Gut",
            "5": "Sehr gut"
          },
          "recommendationScore": "Wie wahrscheinlich ist es, dass du fobizz weiterempfiehlst?",
          "recommendationLow": "Unwahrscheinlich",
          "recommendationHigh": "Sehr wahrscheinlich",
          "continueUsing": "Möchtest du fobizz gern weiter nutzen?",
          "continueUsingTrue": "Ja",
          "continueUsingFalse": "Nein",
          "publicComment": "Deine Rezension der Fortbildung",
          "publicCommentHelp": "Maximal 512 Zeichen eingeben",
          "authorName": "Namensnennung bei der Rezension",
          "authorNameHelp": "z.B. Marie Muster, Grundschullehrerin aus NRW",
          "personalComment": "Persönliches Feedback an die/den Autor*in und das fobizz Team",
          "personalCommentHelp": "Maximal 512 Zeichen eingeben",
          "requestedTopics": "Welche Themen wünschst du dir noch von fobizz?",
          "requestedTopicsHelp": "Maximal 512 Zeichen eingeben",
          "submit": "Abschicken und zum Zertifikat",
          "optional": "(optional)",
          "requiredHint": "Pflichtfeld",
          "errors": {
            "ratingRequired": "Bitte wähle eine Bewertung aus.",
            "recommendationRequired": "Bitte wähle einen Wert zwischen 0 und 10 aus.",
            "continueUsingRequired": "Bitte wähle eine Option aus.",
            "maxLength": "Maximal 512 Zeichen erlaubt."
          }
        }
      },
      "lesson": {
        "headers": {
          "courseContent": "Fortbildungsinhalte"
        },
        "links": {
          "completeAndNext": "Fertig und weiter",
          "complete": "Fertig",
          "next": "Weiter",
          "previous": "Zurück",
          "overview": "Zur Kursübersicht"
        },
        "labels": {
          "complete": "abgeschlossen"
        },
        "paragraphs": {
          "notEnrolled": "Du bist noch nicht in diese Fortbildung eingeschrieben.",
          "notRegistered": "Melde dich an um dich in diese Fortbildung einzuschreiben."
        },
        "blocks": {
          "download": "Download",
          "noPreview": "Keine Vorschau verfügbar",
          "unsupported": "Dieser Inhalt kann nicht dargestellt werden.",
          "videoFallback": "Dein Browser unterstützt keine eingebetteten Videos."
        }
      },
      "recommendations": {
        "empty": "Aktuell gibt es keine Empfehlungen.",
        "error": "Empfehlungen konnten nicht geladen werden."
      },
      "status": {
        "headings": {
          "thanks": "Vielen Dank für dein Feedback!",
          "courseIncomplete": "Fortbildung nicht abgeschlossen",
          "courseIncompleteWebinar": "Webinar nicht abgeschlossen",
          "nextSteps": "Wie geht es weiter?",
          "noFeedback": "Noch kein Feedback gegeben?"
        },
        "paragraphs": {
          "certificate": "Hier findest du nach Abschluss dein Zertifikat.",
          "courseCompleted": "Du hast diese Fortbildung abgeschlossen.",
          "courseCompletedWebinar": "Du hast dieses Webinar abgeschlossen.",
          "courseIncomplete": "Schließe alle Lektionen der Fortbildung ab, um dein Zertifikat zu erhalten.",
          "courseIncompleteWebinar": "Markiere das Webinar als abgeschlossen, um dein Zertifikat zu erhalten.",
          "downloadCertificate": "Lade jetzt dein Zertifikat herunter.",
          "materialsHtml": "Schau doch mal bei den <strong>interaktiven Unterrichtsmaterialien</strong> vorbei, ob du etwas Passendes findest.",
          "certificateNotReady": "Sobald du die Fortbildung abgeschlossen hast, findest du hier dein Zertifikat.",
          "certificateNotReadyWebinar": "Sobald du das Webinar abgeschlossen hast, findest du hier dein Zertifikat."
        },
        "links": {
          "downloadCertificate": "Zertifikat herunterladen",
          "gallery": "Material entdecken",
          "feedback": "Jetzt Fortbildung bewerten",
          "feedbackWebinar": "Jetzt Webinar bewerten"
        }
      },
      "accordion": {
        "feedbackAndCertificate": "Feedback und Zertifikat"
      },
      "format": {
        "title": {
          "b2bWorkshop": "Schulintern & praxisnah",
          "b2cWorkshop": "Live & interaktiv",
          "webinar": "Live & direkt",
          "impulse": "Kurz & Kompakt",
          "course": "Weiterentwicklung im eigenen Tempo"
        },
        "content": {
          "b2bWorkshop": "Workshops bieten maßgeschneiderte Fortbildungen direkt an deiner Schule. Gemeinsam mit dem Kollegium werden praxisnahe Themen erarbeitet, die auf die spezifischen Bedürfnisse und Herausforderungen eurer Einrichtung zugeschnitten sind.",
          "b2cWorkshop": "Workshops sind Live-Webinare mit interaktivem Workshop-Charakter. Hier arbeitest du gemeinsam mit anderen Lehrkräften an praxisnahen Themen und tauschst dich in der Gruppe aus. Perfekt für alle, die sich vernetzen und voneinander lernen möchten.",
          "webinar": "Live-Webinare bei fobizz ermöglichen einen digitalen Austausch mit vielseitigen Referent*innen aus der Bildungslandschaft. Abwechslungsreiche Vorträge und Übungen stoßen neue Impulse, Fragen und Diskussionen an, die über den Austausch mit Kolleg*innen im Lehrerzimmer hinausgehen. Im Anschluss steht häufig eine Aufzeichnung zur Verfügung, für alle, die nicht live dabei sein konnten.",
          "impulse": "Bilde dich in nur 30 Minuten weiter. Erhalte kurze Einblicke in neue Themenwelten oder Unterrichtsideen. Damit kannst du einen kurzen Slot am Tag flexibel und spontan mit einer Portion praxisnahem Wissen füllen - und das in nur einem Video! Für die Begleitung in die Praxis gibt es zu jedem Impuls eine Übung und ein Zusatzmaterial mit dazu. Anschließend an jeden Impuls erhältst du Empfehlungen, wie du dein Wissen selbstständig weiter vertiefen kannst.",
          "course": "Erhalte ausführliche Einblicke zu diversen Themen für den Schulalltag. Ob KI, digitale Methoden, Unterrichtsideen, Lehrer*innengesundheit und vieles mehr! Entwickle dich und deinen Unterricht praxisorientiert und in deinem eigenen Tempo weiter. Aus jeder Online-Fortbildung nimmst du konkrete Konzepte und einsatzbereite Ideen für deinen Unterricht und Arbeitsalltag mit."
        }
      }
    }
  }
}
